/**
 * 盒子-收藏按钮
 * @author VenDream
 * @since 18/03/26
 */
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
// import { flyTo } from 'utils/animation';

import './like-btn.less';

export default function LikeBtn(props) {
  const { isLiked, onClickBtn } = props;
  const cls = classnames('s-icon', isLiked ? 'icon-collect2' : 'icon-shoucang');
  const tips = isLiked ? '取消收藏' : '收藏模板';
  let like;

  return (
    <div
      className="tpl-like-btn"
      title={tips}
      onClick={() => {
        onClickBtn && onClickBtn(like);
      }}>
      <i ref={ref => (like = ref)} className={cls} />
    </div>
  );
}

LikeBtn.propTypes = {
  isLiked: PropTypes.bool,
  onClickBtn: PropTypes.func,
};
